module.exports = __webpack_public_path__ + "MaterialIcons-Regular.a37b0c01c0baf1888ca8.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/GKool/source/repos/e2epublicwebsite/src/assets/fonts/material-design-icons/MaterialIcons-Regular.ttf
// module id = ../../../../../src/assets/fonts/material-design-icons/MaterialIcons-Regular.ttf
// module chunks = 0